export const DEFAULT_REASON_LIST_VALUE_ENUM = {
  CUSTOMER_MADE_A_MISTAKE: "Customer made a mistake",
  REFUND_AMOUNT_IS_INCORRECT: "Refund amount is incorrect",
  ITEM_PREPARED_AS_REQUESTED: "Item prepared as requested",
  ITEM_NOT_PICKED_UP: "Item not picked up",
  ORDER_PICKED_UP_LATE: "Order picked up late",
  ORDER_HANDLED_IMPROPERLY: "Order handled improperly",
  Other: "Other",
}

export const DEFAULT_REASON_LIST_KEY_ENUM = {
  customer_made_a_mistake:'customer_made_a_mistake',
  refund_amount_is_incorrect: 'refund_amount_is_incorrect',
  item_not_picked_up: 'item_not_picked_up',
  item_prepared_as_requested: "item_prepared_as_requested",
  order_picked_up_late: "order_picked_up_late",
  order_handled_improperly: "order_handled_improperly",
  other:'other',
}

export const DEFAULT_REASON_LIST =  [
  {
    index: 1,
    value: DEFAULT_REASON_LIST_VALUE_ENUM.CUSTOMER_MADE_A_MISTAKE,
    key: DEFAULT_REASON_LIST_KEY_ENUM.customer_made_a_mistake
  },
  {
    index: 2,
    value: DEFAULT_REASON_LIST_VALUE_ENUM.REFUND_AMOUNT_IS_INCORRECT,
    key: DEFAULT_REASON_LIST_KEY_ENUM.refund_amount_is_incorrect
  },
  {
    index: 3,
    value: DEFAULT_REASON_LIST_VALUE_ENUM.ITEM_PREPARED_AS_REQUESTED,
    key: DEFAULT_REASON_LIST_KEY_ENUM.item_prepared_as_requested
  },
  {
    index: 4,
    value: DEFAULT_REASON_LIST_VALUE_ENUM.ITEM_NOT_PICKED_UP,
    key: DEFAULT_REASON_LIST_KEY_ENUM.item_not_picked_up
  },
  {
    index: 5,
    value: DEFAULT_REASON_LIST_VALUE_ENUM.ORDER_PICKED_UP_LATE,
    key: DEFAULT_REASON_LIST_KEY_ENUM.order_picked_up_late
  },
  {
    index: 6,
    value:  DEFAULT_REASON_LIST_VALUE_ENUM.ORDER_HANDLED_IMPROPERLY,
    key: DEFAULT_REASON_LIST_KEY_ENUM.order_handled_improperly
  },
  {
    index: 7,
    value: DEFAULT_REASON_LIST_VALUE_ENUM.Other,
    key:DEFAULT_REASON_LIST_KEY_ENUM.other
  },
]
